import { ErpInvoiceState } from "./erpInvoiceState";
import { InvoicePositionDto } from "./invoicePositionDto";

export class InvoiceEditDto {
	public invoiceId: number = 0;
	public orderId: number = 0;
	public companyName: string = "";
	public firstname: string = "";
	public lastname: string = "";
	public email: string = "";
	public street: string = "";
	public zip: string = "";
	public town: string = "";
	public totalAmount: number = 0;
	public mwstAmount: number = 0;
	public mwstSatz: number = 0;
	public currency: string = "";
	public state: ErpInvoiceState = ErpInvoiceState.Unvollstaendig;
	public positions: Array<InvoicePositionDto> = new Array<InvoicePositionDto>();
}
